import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from "vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ListItemGenerator',
  props: {
    existingItems: {
      type: Array,
      required: false,
    },
    itemName: {
      type: String,
      required: true,
      default: "Item",
    },
  },
  emits: ["itemChanged"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const item = ref("");
  const itemList = ref<{ id: string; text: string }[]>([]);
  const emits = __emit;
  const props = __props;
  const itemChanged = () => {
    emits("itemChanged", itemList.value);
  };
  const onAddItem = () => {
    if (item.value.length === 0) {
      return;
    }

    itemList.value = itemList.value.concat({
      id: crypto.randomUUID(),
      text: item.value,
    });
    item.value = "";
    itemChanged();
  };

  const onRemoveItem = (id: string) => {
    itemList.value = itemList.value.filter((el) => el.id !== id);
    itemChanged();
  };
  const setExistingItems = () => {
    if (!props.existingItems) {
      return;
    }

    const existingItems = props.existingItems as string[];

    itemList.value = existingItems.map((text) => ({
      id: crypto.randomUUID(),
      text,
    }));
  };

  onMounted(() => {
    setExistingItems();
  });

  watch(
    () => props.existingItems,
    () => setExistingItems()
  );

const __returned__ = { item, itemList, emits, props, itemChanged, onAddItem, onRemoveItem, setExistingItems, ref, watch, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})